/**
方法声明
*/
 function request(name, action, params = {}) { 
  let service = 'http://api.nuawuk.com/gservice?name='; 
  let url = service + name + '&action=' + action;
  return new Promise((resolve, reject) => {
    let xhr = XMLHttpRequest ? new XMLHttpRequest() : new window.ActiveXObject('Microsoft.XMLHTTP');
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4) {
          if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
              try {
                  //获取数据
                  var response = JSON.parse(xhr.responseText);
                  // console.log(response);
                  if(response.code == 0) {
                     resolve(response.data);
                  }
              } catch (e) {
                  reject(e);
              }
          } else {
              reject(new Error("Request was unsuccessful: " + xhr.statusText));
          }
      }
      xhr.onerror = function() {
        reject(xhr.statusText);
      }
    };
    xhr.open('POST', url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(params));
  });
};

//获取时间戳
function getTimestamp() {
  return request('tools', 'getTimestamp');
};

//调取积分功能相关数据  
async function scoresAjax(action, params = {}) {
  let clientTime = new Date().getTime();
  clientTime = parseInt(clientTime / 1000);
  let timeDiff = localStorage.getItem('time_diff');
  let timestamp = '';
  if (!timeDiff) {
    let serverTime = await getTimestamp();
    timeDiff = serverTime - clientTime;
    timestamp = parseInt(timeDiff) + clientTime;
    localStorage.setItem('time_diff', Math.abs(timeDiff));
  } else {
     timestamp = timeDiff + clientTime;
  }
  let name = 'thirdIntegral';
  let token = md5(name + action + timestamp + 'gmall3_brazil');
  let obj = {
    platform: 'shopify',
    timestamp,
    token,
  }
  // if(action === 'getCustIntegral' || action === 'getCustSignInRecord' || action === 'doSignIn' || action === 'getCustCouponCode' || action === 'addIntegral' || action === 'consumeIntegral') {
  if (action !== 'getAllCouponCode' && action !== 'useCouponCode' && email) {
    params.thirdCustId = email;
  }
  obj = Object.assign(obj, params);
  return request(name, action, obj);
};

function toastMessage(text) {
  let message = `<div class="toast-message" style="position:fixed;width:fit-content;height:fit-content;min-width:120px;top:50%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,.5);color:#fff;border-radius:4px;text-align:center;padding:0.5em 1em;"><span>${text}</span></div>`;
  if($('.toast-message').length > 0) return;
  $('body').append(message);
  setTimeout(() => {
    $('.toast-message').remove();
  },3000);
};
